<mat-form-field>
    <mat-label>{{ 'languages.selectLanguage' | translate }}</mat-label>
  <mat-select name="Language Selector" aria-label="Language select" (selectionChange)="changeLang($event)">
    <mat-option *ngFor="let lang of translate.getLangs()" [value]="lang" >
        {{ 'languages.' + lang | translate }}
    </mat-option>
  </mat-select>
</mat-form-field>
